// extracted by mini-css-extract-plugin
export default {"userProfile":"UserProfile_userProfile__KJ198","userProfileName":"UserProfile_userProfileName__SOs4O","userProfileLogoutButton":"UserProfile_userProfileLogoutButton__pEBT9"};